import React, { useState } from 'react';

import { StyledToggleHeading } from '@pkg/components';
import { Typography, Wrapper } from '@pkg/components/DesignSystem';

import { type EmojiGroupCheckResponse } from '@app/client';

import { EditPatterns } from './EditPatterns';
import { AdminEmojiPatterns } from './Patterns';

export function AdminEmojiGroups() {
    const [serverMatch, setServerMatch] = useState<EmojiGroupCheckResponse>();
    const [showEdit, setShowEdit] = useState(true);
    return (
        <Wrapper>
            <hr />
            <StyledToggleHeading type="button" onClick={() => setShowEdit((c) => !c)}>
                <Typography type="headline" size={20}>
                    {`${showEdit ? 'Hide' : 'Expand'} Edit section`}
                </Typography>
            </StyledToggleHeading>
            <hr />
            {showEdit ? <EditPatterns onServerMatch={(match) => setServerMatch(match)} /> : null}
            <hr />
            <Typography type="headline" size={20}>
                Groups
            </Typography>
            <hr />

            <AdminEmojiPatterns serverMatch={serverMatch} />
        </Wrapper>
    );
}
